module.exports = __webpack_public_path__ + "img/touxiang.7dd5ec7c.png";